import { AppError } from './AppError';

export type RepositoryErrorCode =
  | 'REPO_001' // Query failed
  | 'REPO_002'; // Not found

// Import texts at runtime to avoid circular dependency
const getErrorMessage = (code: RepositoryErrorCode): string => {
  // Dynamic import to avoid circular dependency
  const messages: Record<RepositoryErrorCode, string> = {
    'REPO_001': 'Failed to retrieve data',
    'REPO_002': 'Resource not found'
  };
  return messages[code];
};

export class RepositoryError extends AppError {
  constructor(code: RepositoryErrorCode) {
    const message = getErrorMessage(code);
    super(message, code);
    this.name = 'RepositoryError';
  }

  static queryFailed(): RepositoryError {
    return new RepositoryError('REPO_001');
  }

  static notFound(): RepositoryError {
    return new RepositoryError('REPO_002');
  }
}